import { rangePresets } from '@gogame/intl-ts';

export const FILTER_REGISTRATION_PERIOD = 'registrationPeriod';
export const FILTER_APPLICATIONS = 'applicationIds';
export const FILTER_NETWORKS = 'networkIds';
export const FILTER_PLATFORMS = 'platformIds';
export const FILTER_AFFILIATES = 'affiliateIds';
export const FILTER_REAL_COUNTRIES = 'realCountryIds';

export const FILTER_DEPENDENCIES = {
  [FILTER_NETWORKS]: [FILTER_APPLICATIONS],
  [FILTER_PLATFORMS]: [FILTER_NETWORKS],
  [FILTER_AFFILIATES]: [FILTER_APPLICATIONS],
};

export const PERIOD_PRESETS = [
  rangePresets.YESTERDAY,
  rangePresets.DAY_BEFORE_YESTERDAY,
  rangePresets.THIS_WEEK,
  rangePresets.THIS_MONTH_MINUS_1,
  rangePresets.LAST_3_DAYS,
  rangePresets.LAST_7_DAYS,
  rangePresets.LAST_10_DAYS,
  rangePresets.LAST_14_DAYS,
  rangePresets.LAST_30_DAYS,
  rangePresets.LAST_90_DAYS,
  rangePresets.LAST_MONTH,
  rangePresets.LAST_2_MONTHS,
];

export const REGS_STATS_PAGE = 4;
